module.exports = __webpack_public_path__ + "assets/img/a5a88725baa856ba149a4a01051e11ea.png";